import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { MatCardModule } from '@angular/material/card'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { MatSnackBarModule } from '@angular/material/snack-bar'
import { TranslateModule } from '@ngx-translate/core'

import { PdfReaderComponent } from './components/pdf-reader/pdf-reader.component'
import { PdfTextLayerComponent } from './components/pdf-text-layer/pdf-text-layer.component'

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    MatProgressBarModule,
    MatSnackBarModule,
    FlexLayoutModule,
    TranslateModule,
  ],
  declarations: [
    PdfReaderComponent,
    PdfTextLayerComponent,
  ],
  exports: [
    PdfReaderComponent,
  ],
  providers: [],
})
export class PdfReaderModule { }
